// extracted by mini-css-extract-plugin
export default {"container":"SideBarOffCanvasCustomMove_container__r8HqR","positionSelect":"SideBarOffCanvasCustomMove_positionSelect__vAnse"};